// extracted by mini-css-extract-plugin
export default {"wrapper":"ForgotPassword_wrapper__NjA--","container":"ForgotPassword_container__8CrNO","form_container":"ForgotPassword_form_container__JrWcs"};